import type { FC } from "react";
import { StyleSheet, View } from "react-native";

import { Button, Typography, useTheme } from "@smartrent/ui";

import AppShell from "@/containers/AppShell";
import { useAppState } from "@/context/AppState";

export const MustBe18: FC = () => {
  const { colors } = useTheme();
  const [{ config }] = useAppState();

  return (
    <View style={styles.root}>
      <AppShell header={{ left: null }} showNewTourButton={false}>
        <View
          style={{ flex: 1, justifyContent: "center", alignItems: "center" }}
        >
          <View style={{ alignItems: "center", padding: 16 }}>
            <Typography
              type={"title"}
              style={{ fontWeight: "600", padding: 10 }}
            >
              Unable to Tour
            </Typography>
            <Typography
              type={"title2"}
              style={{
                textAlign: "center",
                fontWeight: "400",
                paddingBottom: 32,
                color: colors.primary,
              }}
            >
              You must be 18 or older to take a Self Guided Tour.
            </Typography>
            <Button
              size="large"
              onPress={() => window.open(`tel:${config.phoneNumber}`)}
              style={{ width: "80%", marginBottom: 20 }}
            >
              Contact Office
            </Button>
          </View>
        </View>
      </AppShell>
    </View>
  );
};

const styles = StyleSheet.create({
  root: {
    width: "100%",
    height: "100%",
    position: "relative",
  },
});
